import React from "react";
import Navbar from "../../components/layout/Navbar";
import { Link } from "react-router-dom";
import { useEnglishText } from "../../text/useEnglishText.js";
import "../../App.css";
function ErrorPage() {
  const { t } = useEnglishText();
  return (
    <div className="Error">
      <Navbar />
      <div className="DivError">
        <h1>
         {t("AppName")}
        </h1>
        <h2>Dear user, there is no page with this path.</h2>
        <div className="DivImageError">
          <Link to="/">
            <img
              src="/assets/images/error/error404.png"
              alt="Js Ai Studio"
              className="ImageError"
              loading="lazy"
              style={{
                filter: "blur(10px)",
                transition: "filter 0.5s ease",
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/assets/images/error/error500.png";
              }}
              onLoad={(e) => {
                e.target.style.filter = "blur(0px)";
              }}
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
